// extracted by mini-css-extract-plugin
export default {"wrapper":"we","focus":"xe","button":"ye","options":"ze","label":"Ae"};